/**
 * Hook para grabación de voz
 */

import { useState, useRef, useCallback } from 'react';
import { AudioRecorderHelper } from '../utils/audioHelpers';
import { loadPolyfills } from '../utils/polyfills';

export interface UseVoiceRecorderReturn {
  isRecording: boolean;
  startRecording: () => Promise<void>;
  stopRecording: () => Promise<Blob | null>;
  error: string | null;
}

export function useVoiceRecorder(): UseVoiceRecorderReturn {
  const [isRecording, setIsRecording] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const recorderRef = useRef<AudioRecorderHelper | null>(null);

  const startRecording = useCallback(async () => {
    try {
      setError(null);
      
      // Cargar polyfills si es necesario
      await loadPolyfills();

      if (!recorderRef.current) {
        recorderRef.current = new AudioRecorderHelper();
      }

      await recorderRef.current.startRecording();
      setIsRecording(true);
    } catch (err: any) {
      setError(err.message || 'Error al iniciar la grabación');
      setIsRecording(false);
      console.error('Error al iniciar grabación:', err);
    }
  }, []);

  const stopRecording = useCallback(async (): Promise<Blob | null> => {
    try {
      if (!recorderRef.current || !isRecording) {
        return null;
      }

      const audioBlob = await recorderRef.current.stopRecording();
      setIsRecording(false);
      return audioBlob;
    } catch (err: any) {
      setError(err.message || 'Error al detener la grabación');
      setIsRecording(false);
      console.error('Error al detener grabación:', err);
      return null;
    }
  }, [isRecording]);

  return {
    isRecording,
    startRecording,
    stopRecording,
    error,
  };
}


